export enum IdentificationMode {
    LOGIN,
    VERIFY_LOGIN,
    REGISTER,
    REGISTRATION_DETAILS,
    VERIFY_REGISTRATION,
    CONFIRM,
    ENABLE_ACCOUNT,
    FORGOT_PASSWORD,
    SET_PASSWORD,
    RESET_PASSWORD
}
